import { Component, Input } from '@angular/core';
import { RankingItem, TrendIcon } from '@interfaces';

@Component({
  selector: 'unicon-ranking-item',
  templateUrl: './ranking-item.component.html',
  styleUrl: './ranking-item.component.scss',
})
export class RankingItemComponent {
  @Input() items: RankingItem[] = [];
  @Input() title: string = '';
  @Input() type: 'collaborator' | 'noCollaborator' = 'collaborator'; // Para diferenciar
  @Input() headers: { label: string; colSpan?: number }[] = [];

  protected getBadgeText(user: RankingItem) {
    if (user) {
      const fullname: string = user.name;
      if (fullname) {
        const slices: string[] = fullname.split(' ');
        return slices[0][0] + (slices[1] ? slices[1][0] : '');
      }
      return '';
    }
    return '';
  }

  protected getTrendIcon(item: RankingItem): TrendIcon {
    const noPreviousData = item.previousPosition === 0;
    if (!noPreviousData && item.previousPosition === item.position) {
      return { icon: '=', color: 'text-gray-400' };
    }
    if (!noPreviousData && item.previousPosition > item.position) {
      return { icon: '▲', color: 'text-green-500' };
    }
    if (!noPreviousData && item.previousPosition < item.position) {
      return { icon: '▼', color: 'text-red-500' };
    }
    return { icon: '', color: '' };
  }
}
